import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const cultureAmp = defineConnector({
  identifier: "cultureAmp",
  name: "Culture Amp",
  tagLine: "Employee engagement and performance platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.cultureamp\\.com/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://api.cultureamp.com/oauth/token",
        jsonBody: {
          grant_type: "client_credentials",
          client_id: app.secret.clientId,
          client_secret: app.secret.clientSecret,
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In [Culture Amp](https://www.cultureamp.com/), go to **Account administration → API credentials** and generate a new client ID and client secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "secrets", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.cultureamp.com/v1/surveys",
  },
});
